import { Typography, styled } from "@mui/material"

export const STATUS_COLOR = {
  SENDING: "grey.light",
  ERROR: "common.orange",
  REFUSED: "common.orangeDark2",
  UNSIGNED: "common.blue",
  SIGNED: "success.main",
  ALL: "primary.dark1",
}

export const Label = styled(Typography)(({ theme: { typography, palette } }) => ({
  ...typography["10px"],
  color: palette.primary.light1,
}))
